<template>
  <div class="bg-[#232323]">

    <footer class=" text-white pt-[76px]  text-[14px] bg_img">
      <div class="max-w-[1200px] mx-auto ">
        <div class="flex justify-between mb-[40px]">
          <div class="w-2/6">
            <div class=" mb-6"><i class="iconfont-logo logoIcon-fazhibaohantonglogo text-[22px] text-[#fff]"></i> <span
                class="font-bold text-[18px]">法智保诉讼保全保函平台</span> </div>
            <p class=" text-base leading-relaxed">
              专注诉讼保全保函的电子保函综合服务平台，提供诉讼保全保函在线办理服务。我们致力于为客户提供专业、高效、安全的诉讼保全解决方案。
            </p>
          </div>

          <div class="w-2/6 pl-[30px]">
            <h3 class="text-[14px] font-bold mb-6">联系我们</h3>
            <div class="space-y-3">
              <p class="text-[20px]" v-if="linkData.telephone">{{linkData.telephone}}</p>
              <p class="text-[20px]" v-if="linkData.telephoneReservation">{{linkData.telephoneReservation}}</p>
              <p class="text-[#C0C4CC]">联系手机：{{linkData.mobile}}</p>
              <p class="text-[#C0C4CC]">邮箱：{{linkData.email}}</p>
              <p class="text-[#C0C4CC]">地址：北京市门头沟区军庄镇军庄路2号院JZ2706室</p>
            </div>
          </div>

          <div class="w-1/4 flex justify-between">
            <div class="w-1/2">
              <h3 class="text-[14px] font-bold mb-6">快速导航</h3>
              <ul class="space-y-2 text-gray-300">
                <li><a href="#/scene" class="text-[#C0C4CC] hover:text-white">场景应用</a></li>
                <li><a href="#/finance" class="text-[#C0C4CC] hover:text-white">金融机构</a></li>
                <li><a href="#/news" class="text-[#C0C4CC] hover:text-white">政策资讯</a></li>
                <li><a href="#/introduce" class="text-[#C0C4CC] hover:text-white">关于我们</a></li>
              </ul>
            </div>
            <div class="">
              <h3 class="text-[14px] font-bold mb-6">掌上办理</h3>
              <div class="w-[88px] h-[88px] bg-white p-2">
                <!-- <img src="../assets/img/img17.png" alt="微信小程序" class="w-full h-full object-cover"> -->
                <img :src="linkData.wechatQrCode" alt="微信小程序" class="w-full h-full object-cover">
              </div>
              <p class="text-sm text-gray-300 mt-2 text-center">微信小程序</p>
            </div>
          </div>
        </div>


        <div class="text-center text-[#909399] text-sm space-y-2 pb-[10px]">
          <p class="text-[12px] py-[7px] border-y ">建设单位：北京法智通科技有限公司</p>
          <p class="text-[12px]">声明：本平台仅提供技术支持，所有保函产品均由保函下发金融机构提供，销售、理赔等服务均由本平台合作的金融机构提供</p>
          <p class="text-[12px]">
            <img src="../assets/img/gov.png" class="inline w-[16px] mr-[3px]" alt="">
            <a class="text-[12px]" href="https://beian.miit.gov.cn/#/Integrated/index">京ICP备2025111099号-2</a>
          </p>
        </div>

      </div>
    </footer>

  </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
  mixins: [mixin],
  name: 'dg-footer',
  props: {
    linkData:{
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  methods: {},
  mounted() { },
  created() { },
}
</script>
<style scoped lang="less">
.bg_img {
  background-image: url('../assets/img/bg18.png');
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.border-y{
  border-color: rgba(255, 255, 255, 0.1);
}
</style>
